import Chrome from '@uiw/react-color-chrome';
import React, { useState } from 'react';
import { titleCase } from 'title-case';
import settingsStyles from '../ModalSettings/ModalSettings.module.scss';
import styles from './colorSelector.module.scss';

const ColorSelector = ({ id, title, color, colorChange, right = false }) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleColorChange = (newColor) => {
    colorChange(newColor, id);
  };

  return (
    <div className={styles.wrapper}>
      <div className={settingsStyles.title}>{titleCase(title)}</div>
      <div className={styles.input_wrapper}>
        <input
          type="text"
          value={color}
          onChange={(e) => handleColorChange(e.target.value, 'form')}
          className={`form-control ${styles.color_input}`}
          aria-label={title}
          onFocus={() => setShowColorPicker(true)}
        />
        <div
          role="presentation"
          className={styles.color_preview}
          style={{ backgroundColor: color }}
          onClick={() => setShowColorPicker(!showColorPicker)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setShowColorPicker(!showColorPicker);
            }
          }}
        />
      </div>
      {showColorPicker && (
        <div
          className={`${styles.color_picker_wrapper} ${right ? styles.right : ''}`}
        >
          <div
            role="presentation"
            onClick={() => setShowColorPicker(false)}
            className={styles.color_picker}
          />
          <Chrome
            inputType="hexa"
            color={color}
            onChange={(newColor) => {
              handleColorChange(newColor.hexa, 'form');
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ColorSelector;
